// sessionWS.js — satu pintu untuk logout & registry socket device WS.
//
// Socket device (ws/cek-status) dimiliki AdminLayout. Komponen lain
// (AdminHeader, AdminSider, MobileBottomNav) yang butuh mengirim logout
// TIDAK membuka WebSocket sendiri — panggil doLogout() dari sini.
//
// Prinsip keamanan/ketahanan: logout TIDAK boleh bergantung pada server.
// Apa pun kondisi WS (down, lambat, gagal open), session lokal (cookies,
// redux) selalu dibersihkan — paling lambat FALLBACK_TIMEOUT_MS kemudian.

import Cookies from 'js-cookie';
import Config from '../Config';

const config = new Config();
const FALLBACK_TIMEOUT_MS = 2000;

let deviceSocket = null;

export function registerDeviceSocket(socket) {
	deviceSocket = socket;
}

export function unregisterDeviceSocket(socket) {
	if (deviceSocket === socket) deviceSocket = null;
}

export function getDeviceSocket() {
	return deviceSocket;
}

// Bersihkan seluruh jejak session di sisi client (cookies + redux).
export function clearLocalSession(setConfig) {
	const name = config.get_cookie_name();
	Cookies.remove(name);
	Cookies.remove(name + '_upt');
	Cookies.remove(name + '_isNotice');
	Cookies.remove(name + '_username');
	Cookies.remove(name + '_expiry');
	Cookies.remove(name + '_refresh');
	localStorage.removeItem('logout');
	if (setConfig) {
		setConfig({
			uptDipilih: '', isLogin: false, username: '', nama: '',
			id: '', pp: '', alamat: '', no_hp: '', layanan_id: [], layanan_str: [],
		});
	}
}

// Logout terpusat.
// 1) Jalur utama: kirim {type:'logout'} lewat socket device milik AdminLayout.
// 2) Fallback: WS sekali-pakai bila socket utama tidak tersedia.
// 3) Apa pun hasilnya: clearLocalSession + reload tetap dijalankan.
export function doLogout(setConfig, { reload = true } = {}) {
	const raw = Cookies.get(config.get_cookie_name() + '_username');
	const user = typeof raw === 'string' ? raw.split('_') : [];
	const username = user[2];
	const deviceId = localStorage.getItem('device_id');
	const payload = JSON.stringify({ type: 'logout', username, device_id: deviceId });

	let done = false;
	const finish = () => {
		if (done) return;
		done = true;
		clearLocalSession(setConfig);
		if (reload) window.location.reload();
	};

	// Jalur utama — socket sudah terbuka, kirim lalu langsung selesai.
	if (deviceSocket && deviceSocket.readyState === WebSocket.OPEN) {
		try { deviceSocket.send(payload); } catch (e) { /* tetap lanjut */ }
		finish();
		return;
	}

	// Fallback — WS sekali-pakai, dengan batas waktu.
	if (username) {
		try {
			// ws/cek-status wajib JWT (lihat samsat/consumers.py DeviceConsumer,
			// require_auth=True) - tanpa ini socket fallback akan langsung ditolak.
			const rawToken = Cookies.get(config.get_cookie_name()) || '';
			const token = rawToken.replace('Bearer ', '').trim();
			const ws = new WebSocket(
				config.get_web_socket() + `/ws/cek-status/${username}/?token=${token}&device_id=${deviceId}/`
			);
			ws.onopen = () => {
				try {
					ws.send(payload);
					ws.close(1000, 'Logout sent');
				} catch (e) { /* tetap lanjut */ }
				finish();
			};
			ws.onerror = finish;
		} catch (e) {
			finish();
			return;
		}
		setTimeout(finish, FALLBACK_TIMEOUT_MS);
	} else {
		finish();
	}
}
